import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

import { RouteId } from '../RouteId';

export const AuthCallback = () => {
  const { isAuthenticated, isLoading, error, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (error) {
      console.error('[OIDC] callback error:', error);
      navigate(RouteId.login, { replace: true });
      return;
    }

    if (isAuthenticated) {
      const destination = (user?.state as { returnUrl?: string })?.returnUrl || '/';

      // Strip OIDC query params from the address bar
      window.history.replaceState({}, '', destination);

      if (window.self === window.top) {
        navigate(destination, { replace: true });
      }
    }
  }, [error, isAuthenticated, isLoading, navigate, user?.state]);

  return null;
};
